import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { updateProductViewCount } from "../../../actions/products";
import {
  Container,
  Grid,
  Paper,
  Divider,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";
import parse from "html-react-parser";
import priceIcon from "../../../images/price-tag.svg";
import discountIcon from "../../../images/discount-tag.svg";
import ProductViewCountIcon from "../../icons/ProductViewCountIcon";
import websiteCouponIcon from "../../../images/website-coupon-icon.svg";
import countdownIcon from "../../../images/countdown-icon.svg";
import promoCodeIcon from "../../../images/promo-code-icon.svg";
import { fetchProduct } from "../../../api";
import useStyles from "./styles";
import Countdown from "react-countdown";
import { AMAZON_USA } from "../../../constants/amazonStores";

function ProductInfo({ match }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Loading...";
    const getProduct = async () => {
      const productInfo = await fetchProduct(match.params.id, {
        amazon_store: AMAZON_USA,
      });
      setProductData(productInfo);
      setLoading(false);
      document.title = productInfo ? productInfo.name : "Error - Product not ";
    };

    setTimeout(() => {
      getProduct();
    }, 600);
  }, [match]);

  const getDiscountPercentage = (productOriginalPrice, productNewPrice) => {
    return `-${Math.round(
      ((productOriginalPrice - productNewPrice) / productOriginalPrice) * 100
    )}%`;
  };

  const handleViewCount = (productId, productLink) => {
    window.open(productLink);
    dispatch(updateProductViewCount(productId, { amazon_store: AMAZON_USA }));
    setProductData({ ...productData, viewCount: productData.viewCount + 1 });
  };

  const renderInfo = () => {
    if (!loading) {
      if (productData) {
        return (
          <Container maxWidth={false}>
            <Grid container className={classes.gridContainer} spacing={2}>
              <Grid item xs={12}>
                <Paper elevation={3}>
                  <Grid container className={classes.gridContainer} spacing={1}>
                    <Grid item lg={4} sm={6} xs={12}>
                      <div className={`${classes.flex} ${classes.image}`}>
                        <img src={productData.imageUrl} alt="" height={225} />
                      </div>
                    </Grid>
                    <Grid item lg={8} sm={6} xs={12}>
                      <div className={classes.productMainInfo}>
                        <div>
                          <Typography
                            variant="subtitle1"
                            className={classes.productName}
                          >
                            {productData.name}
                          </Typography>
                        </div>
                        {productData.category === "HOT_DEALS" ? (
                          <Paper
                            elevation={2}
                            className={classes.productMainInfoPaper}
                          >
                            <div className={classes.productViewCount}>
                              <img
                                src={priceIcon}
                                alt="Price Icon"
                                height={25}
                                width={25}
                              />
                              &nbsp;
                              <Typography
                                variant="subtitle2"
                                className={classes.productOldPrice}
                              >
                                {`${Number(productData.originalPrice).toFixed(
                                  2
                                )}`}
                              </Typography>
                              &nbsp;
                              {productData.newPrice && (
                                <Typography
                                  variant="h5"
                                  className={classes.productNewPrice}
                                >
                                  {`${Number(productData.newPrice).toFixed(2)}`}
                                </Typography>
                              )}
                            </div>
                            <div className={classes.productViewCount}>
                              <img
                                src={discountIcon}
                                alt="Discount Icon"
                                height={25}
                                width={25}
                              />
                              &nbsp;
                              <Typography
                                variant="subtitle1"
                                className={classes.productDiscount}
                              >
                                {productData.discountPercentage
                                  ? `-${productData.discountPercentage}%`
                                  : getDiscountPercentage(
                                      productData.originalPrice,
                                      productData.newPrice
                                    )}
                              </Typography>
                            </div>
                            {productData.websiteCoupon && (
                              <div className={classes.productViewCount}>
                                <img
                                  src={websiteCouponIcon}
                                  alt="Website Coupon Icon"
                                  height={25}
                                  width={25}
                                />
                                &nbsp;
                                <Typography
                                  variant="subtitle1"
                                  className={classes.productDiscount}
                                >
                                  {`SAVE ${productData.websiteCoupon} EXTRA WITH COUPON!`}
                                </Typography>
                              </div>
                            )}
                            <div className={classes.productViewCount}>
                              <ProductViewCountIcon />
                              &nbsp;
                              <Typography
                                variant="subtitle1"
                                className={classes.productViewCountText}
                              >
                                {productData.viewCount}
                              </Typography>
                            </div>
                          </Paper>
                        ) : (
                          <div>
                            <Paper
                              elevation={2}
                              className={classes.productMainInfoPaper}
                            >
                              <div className={classes.productViewCount}>
                                <img
                                  src={priceIcon}
                                  alt="Price Icon"
                                  height={25}
                                  width={25}
                                />
                                &nbsp;
                                <Typography
                                  variant="subtitle2"
                                  className={classes.productNewPrice}
                                >
                                  {`${Number(productData.originalPrice).toFixed(
                                    2
                                  )}`}
                                </Typography>
                              </div>
                              {productData.websiteCoupon && (
                                <div className={classes.productViewCount}>
                                  <img
                                    src={websiteCouponIcon}
                                    alt="Website Coupon Icon"
                                    height={25}
                                    width={25}
                                  />
                                  &nbsp;
                                  <Typography
                                    variant="subtitle1"
                                    className={classes.productDiscount}
                                  >
                                    {`SAVE ${productData.websiteCoupon} EXTRA WITH COUPON!`}
                                  </Typography>
                                </div>
                              )}
                              <div className={classes.productViewCount}>
                                <ProductViewCountIcon />
                                &nbsp;
                                <Typography
                                  variant="subtitle1"
                                  className={classes.productViewCountText}
                                >
                                  {productData.viewCount}
                                </Typography>
                              </div>
                            </Paper>
                            <Paper
                              elevation={2}
                              className={classes.productMainInfoPaper}
                            >
                              <div className={classes.productViewCount}>
                                <img
                                  src={countdownIcon}
                                  alt="Countdown Icon"
                                  height={25}
                                  width={25}
                                />
                                &nbsp;
                                <Typography
                                  variant="h5"
                                  className={classes.productViewCountText}
                                >
                                  <Countdown date={productData.dueDate} />
                                </Typography>
                              </div>
                              <div className={classes.productViewCount}>
                                <img
                                  src={promoCodeIcon}
                                  alt="Promo Code Icon"
                                  height={25}
                                  width={25}
                                />
                                &nbsp; &nbsp;
                                <Typography
                                  variant="subtitle1"
                                  className={classes.productPromoCodeText}
                                >
                                  {productData.promoCode &&
                                    productData.discountPercentage &&
                                    `-${productData.discountPercentage}% with promo code: ${productData.promoCode}`}
                                </Typography>
                              </div>
                            </Paper>
                          </div>
                        )}
                        <div className={classes.flex}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.buyOnAmazon}
                            onClick={() =>
                              handleViewCount(
                                productData._id,
                                productData.affiliateLink
                              )
                            }
                          >
                            <b>Buy product</b>
                          </Button>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider className={classes.divider} />
                      <div className={classes.productDescription}>
                        {parse(productData.description)}
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Paper elevation={3}>
                <Typography
                  variant="subtitle1"
                  className={`${classes.flex} ${classes.header}`}
                >
                  About Us
                </Typography>
                <Divider className={classes.divider} />
                <Typography variant="body1" className={classes.disclaimer}>
                  <b>COSMOS OFFER CLUB</b> is a participant in {" "}
                  <b>
                    various affiliate programs
                  </b>
                  , designed to provide a means for sites to earn advertising
                  fees by advertising and linking, without any charges to the
                  buyer.
                </Typography>
              </Paper>
            </Grid>
          </Container>
        );
      } else {
        return <Redirect to="/404" />;
      }
    }

    return (
      <div className={`${classes.flex} ${classes.loaderContainer}`}>
        <CircularProgress className={classes.loader} />
      </div>
    );
  };

  return renderInfo();
}

export default ProductInfo;
